import React, { useState, useEffect, useRef } from "react";
import { Form } from 'react-bootstrap';
import "./Account.css";
import "../../assets/css/modal.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getCustomerProfile, updateCustomerProfile } from "../../actions/authActions";
import UpdateProfile from "../../components/Modals/UpdateProfile";
import { set, useForm } from "react-hook-form";
import ChangePassword from "../../components/Modals/ChangePassword";
import { FiUser, FiMail, FiPhone, FiLock, FiSave } from "react-icons/fi";

const Account = (props) => {
  const [updatedFirstName, setUpdatedFirstName] = useState("");
  const [updatedLastName, setUpdatedLastName] = useState("");
  const [updatedEmail, setUpdatedEmail] = useState("");
  const [updatedPhone, setUpdatedPhone] = useState("");
  const [phoneCode, setPhoneCode] = useState('+65');
  const [phoneCodeVal, setPhoneCodeVal] = useState("SG")
  const phoneCodeElement = useRef(null)
  const [phoneNumber, setPhoneNumber] = useState('');
  const [fname, setFname] = useState(null);
  const [lname, setlName] = useState(null);
  const [emaill, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);

  const [fnameStatus, setFnameStatus] = useState("");
  const [lnameStatus, setlnameStatus] = useState("");
  const [phoneNoStatus, setPhoneNoStatus] = useState("ERROR");

  const [load, setLoad] = useState(false);
  const [show, setShow] = useState(false);
  const [popupTxt, setPopupTxt] = useState("")
  const [lshow, setLshow] = useState(false);
  const [hover, setHover] = useState(false);

  const countries = [{
    'name': 'SG',
    'code': '+65'
  }]


  const { register, handleSubmit } = useForm();
  const [canSubmit, setSubmitState] = useState(false);

  const getLoginData = () => {
    try {
      if (localStorage.headers) {
        return JSON.parse(window.localStorage.getItem('headers'));
      }
    } catch (e) {
      return null;
    }
    return null;
  };

  const login = getLoginData();
  const userid = login?.data?.user?.user_id;

  useEffect(() => {
    if (!load) {
      props.getCustomerProfile();
      setLoad(true);
    }
    setUpdatedFirstName(login?.data?.user?.fname === "NA" ? "" : login?.data?.user?.fname);
    setUpdatedLastName(login?.data?.user?.lname);
    setUpdatedPhone(login?.data?.user?.contactNo);
    setEmail(login?.data?.user?.email);

    if (props.update_customer_profile !== null) {
      if (props.update_customer_profile.message === 'Update user profile successful.') {
        if (login) {
          login.data.user.fname = updatedFirstName;
          login.data.user.lname = updatedLastName;
          localStorage.setItem('headers', JSON.stringify(login));
        }
        setPopupTxt("User profile updated successfully.");
        setLshow(true);
      } else {
        console.log(props.update_customer_profile.message);
        setPopupTxt("Update failed. Please try again.");
        setLshow(true);
      }
    }
  }, [props, load]);

  useEffect(() => {
    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
    const phoneNoRegex = /^\+65(6|8|9)\d{7}$/;
    // setSubmitState(false);
    {/*  if (updatedFirstName == "") {
      setFnameStatus("");
    } else {
      if (nameRegex.test(updatedFirstName)) {
        setFnameStatus(<div className="footer-warley-description text-success">Valid Name</div>)
      } else {
        setFnameStatus(<div className="footer-warley-description text-danger">Invalid Name</div>)
      }
    }

    if (updatedLastName == "") {
      setlnameStatus("");
    } else {
      if (nameRegex.test(updatedLastName)) {
        setlnameStatus(<div className="footer-warley-description text-success">Valid Name</div>)
      } else {
        setlnameStatus(<div className="footer-warley-description text-danger">Invalid Name</div>)
      }
    } */}

    const getError = (value, regex, errorMsg) =>
      value === "" || regex.test(value)
        ? ""
        : <div className="footer-warley-description text-danger">{errorMsg}</div>;

    setFnameStatus(getError(updatedFirstName, nameRegex, "Invalid Name"));
    setlnameStatus(getError(updatedLastName, nameRegex, "Invalid Name"));
    setPhoneNoStatus(getError(updatedPhone, phoneNoRegex, "Invalid Phone Number"));

    setSubmitState(
      nameRegex.test(updatedFirstName) &&
      nameRegex.test(updatedLastName) &&
      phoneNoRegex.test(updatedPhone)
    );

    // if (updatedPhone == "") {
    //   setPhoneNoStatus("");
    // } else {
    //   if (phoneNoRegex.test(updatedPhone)) {
    //     setPhoneNoStatus(<div className="footer-warley-description text-success">Valid Phone Number</div>)
    //   } else {
    //     setPhoneNoStatus(<div className="footer-warley-description text-danger">Invalid Phone Number</div>)
    //   }
    // }

    // if (nameRegex.test(updatedFirstName) && nameRegex.test(updatedLastName) && phoneNoRegex.test(updatedPhone)) {
    //   setSubmitState(true);
    // }

    setSubmitState(
      nameRegex.test(updatedFirstName) &&
      nameRegex.test(updatedLastName) &&
      phoneNoRegex.test(updatedPhone)
    );
  }, [updatedFirstName, updatedLastName, updatedPhone]);


  function updateFirstName(event) {
    const value = event.target.value;
    setUpdatedFirstName(value);

    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

    if (value === "") {
      setFnameStatus(""); // hide message if empty
    } else if (nameRegex.test(value)) {
      setFnameStatus(
        <div className="footer-warley-description text-success">
          Valid Name
        </div>
      );
    } else {
      setFnameStatus(
        <div className="footer-warley-description text-danger">
          Invalid Name
        </div>
      );
    }
  }

  function updateLastName(event) {
    const value = event.target.value;
    setUpdatedLastName(value);

    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

    if (value === "") {
      setlnameStatus(""); // hide message if empty
    } else if (nameRegex.test(value)) {
      setlnameStatus(
        <div className="footer-warley-description text-success">
          Valid Name
        </div>
      );
    } else {
      setlnameStatus(
        <div className="footer-warley-description text-danger">
          Invalid Name
        </div>
      );
    }
  }



  function updateEmail(event) {
    if (updatedEmail === null) {
      setUpdatedEmail(emaill)
    } else { setUpdatedEmail(event.target.value) }
    console.log(updatedEmail)
  }

  function updatePhoneCode(event) {
    var newPhoneCode = event.target.value;
    setPhoneCodeVal(event.target.name)
    setPhoneNumber(phoneNumber.replace(phoneCode, newPhoneCode));
    setPhoneCode(newPhoneCode);
  }

  function updatePhone(event) {
    if (updatedPhone === null) {
      setUpdatedPhone(phone)
      console.log(phone)
    } else { setUpdatedPhone(event.target.value) }
  }

  //Validating the submit state
  if (document.querySelector("#updateButton")) { //Check if not null
    if (canSubmit === false) {
      document.querySelector("#updateButton").style.opacity = 0.5
      document.querySelector("#updateButton").disabled = true
    } else {
      document.querySelector("#updateButton").style.opacity = 1.0
      document.querySelector("#updateButton").disabled = false
    }
  }

  const onSubmit = () => {
    const data = {
      id: userid,
      first_name: updatedFirstName,
      last_name: updatedLastName,
      phone: updatedPhone,
    };
    props.updateCustomerProfile(data);
  }

  const showModal = (event, val) => {
    event && event.preventDefault();
    setShow(val);
  };

  return (
    <>
      <UpdateProfile
        text={popupTxt}
        show={lshow}
        closeModal={() => setLshow(false)}
      />
      <ChangePassword
        show={show === 1 ? true : false}
        closeModal={() => setShow(null)}
      />

      <div className="acc-page-wrapper">
        <div className="acc-card">
          <form onSubmit={handleSubmit(onSubmit)}>

            <div className="d-flex justify-content-center mb-4">
              <h2>User Information</h2>
            </div>

            <div className="acc-grid">

              {/* First Name */}
              <div className="acc-field-group">
                <label className="acc-label">
                  First Name <span className="acc-required">*</span>
                </label>
                <div className="acc-input-wrap">
                  <FiUser className="acc-input-icon" />
                  <input
                    type="text"
                    autoComplete="off"
                    onChange={updateFirstName}
                    value={updatedFirstName}
                    placeholder="Enter first name"
                    className="acc-input"
                    required
                    aria-required="true"
                  />
                </div>
                <div className="acc-feedback">{fnameStatus}</div>
              </div>

              {/* Last Name */}
              <div className="acc-field-group">
                <label className="acc-label">
                  Last Name <span className="acc-required">*</span>
                </label>
                <div className="acc-input-wrap">
                  <FiUser className="acc-input-icon" />
                  <input
                    type="text"
                    autoComplete="off"
                    onChange={updateLastName}
                    value={updatedLastName}
                    placeholder="Enter last name"
                    className="acc-input"
                    required
                    aria-required="true"
                  />
                </div>
                <div className="acc-feedback">{lnameStatus}</div>
              </div>

              {/* Phone Number */}
              <div className="acc-field-group">
                <label className="acc-label">Phone Number</label>
                <div className="acc-input-wrap acc-phone-wrap">
                  <FiPhone className="acc-input-icon" />
                  <Form.Control
                    as="select"
                    {...register("ccode")}
                    onChange={updatePhoneCode}
                    className="acc-phone-select"
                  >
                    {countries.map(({ name, phoneCode }) => (
                      <option key={name} value={phoneCode} name={name}>{name}</option>
                    ))}
                  </Form.Control>
                  <input
                    autoComplete="off"
                    {...register("phone")}
                    placeholder="Phone number"
                    minLength="8"
                    onChange={updatePhone}
                    value={updatedPhone}
                    required
                    disabled
                    className="acc-input acc-phone-number"
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
                <div className="acc-feedback">{phoneNoStatus}</div>
              </div>

              {/* Email Address */}
              <div className="acc-field-group">
                <label className="acc-label">Email Address</label>
                <div className="acc-input-wrap">
                  <FiMail className="acc-input-icon" />
                  <input
                    type="email"
                    autoComplete="off"
                    onChange={updateEmail}
                    value={updatedEmail}
                    placeholder={emaill}
                    disabled
                    className="acc-input"
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>

            </div>

            {/* Action Buttons */}
            <div className="acc-actions">
              <button
                type="button"
                className="acc-btn-outline"
                onClick={(event) => showModal(event, 1)}
              >
                <FiLock size={15} style={{ marginRight: 7 }} />
                Change Password
              </button>
              <button
                id="updateButton"
                type="submit"
                className="acc-btn-primary"
                disabled={!canSubmit}
              >
                <FiSave size={15} style={{ marginRight: 7 }} />
                Save Changes
              </button>
            </div>

          </form>
        </div>
      </div>
    </>
  );
};

Account.propTypes = {
  // closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  customer_profile: state.auth.customer_profile,
  update_customer_profile: state.auth.update_customer_profile,
  errors: state.auth.errors
});
export default withTranslation()(
  connect(mapStateToProps, { getCustomerProfile, updateCustomerProfile })(Account)
);
